import { Injectable } from '@angular/core';
import { Camera, ImageOptions, Photo } from '@capacitor/camera';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  getPhoto(cameraOptions: ImageOptions): Promise<Photo> {
    return Camera.getPhoto(cameraOptions);
  }
}
